
























import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Report,
  getEntriesInCurrentFolder,
  saveReportEntry,
  deleteReportEntry,
  readReportEntry
} from "@/api/report-api";
import { FolderEntry, Breadcrumb } from "@/models/file";

import FileExplorer from "@/templates/FileExplorer.vue";
import formatDate from "../helpers/formatDate";
import NewFolderRequest from "@/models/new-folder-request";
import NewFolderModal from "../components/NewFolderModal.vue";

@Component({
  components: {
    NewFolderModal,
    FileExplorer
  }
})
export default class ReportListPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  currentFolderId: any = "0";
  entries: FolderEntry[] = [];
  breadcrumbs: Breadcrumb[] = [];

  inEdit = false;

  newFolderRequest = new NewFolderRequest();

  showNewFolderModal() {
    this.newFolderRequest = new NewFolderRequest();
    this.newFolderRequest.name = "新しいフォルダ";
    this.newFolderRequest.projectId = this.projectId;
    this.newFolderRequest.parentFolderId = this.currentFolderId;
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  canWriteReport() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/document_secret") ||
      (this.permissions.includes("project/task_operation") &&
        this.permissions.includes("service/master_read") &&
        this.permissions.includes("project/report_operation"))
    );
  }

  private created() {
    this.initEntries();
  }

  private goNewPage() {
    const params = {
      projectId: this.projectId,
      folderId: this.currentFolderId
    };
    this.$router.push({ name: "report-new", params });
  }

  private goShowPage(entry: FolderEntry) {
    const params = {
      projectId: this.projectId,
      folderId: this.currentFolderId,
      reportId: String(entry.entryId)
    };
    this.$router.push({ name: "report-show", params });
  }

  /** 共通 **/

  open(entry: FolderEntry, _index: number) {
    switch (entry.kind) {
      case "folder":
        // this.currentFolder = entry as Folder;
        this.changeCurrentFolder(entry.entryId);
        break;
      case "file":
        readReportEntry(entry.entryId);
        // this.currentReport = entry as Report;
        this.initEntries();
        this.goShowPage(entry);
        break;
    }
  }

  changeCurrentFolder(id: any) {
    this.currentFolderId = id;
    this.initEntries();
  }

  private async initEntries() {
    const { entries, path } = await getEntriesInCurrentFolder(
      this.projectId,
      this.currentFolderId
    );
    this.entries = entries;
    this.breadcrumbs = path;
  }

  async addFolder() {
    await saveReportEntry(this.newFolderRequest.toFormData());
    await this.initEntries();
  }

  async mv(id: any, folderId: any) {
    const entry = this.entries.find(e => String(e.entryId) === id) as
      | Report
      | undefined;
    if (!entry) return;
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", entry.name);
    data.append("kind", entry.kind);
    data.append("projectId", this.projectId);
    data.append("parentFolderId", folderId);
    if (entry.scenes) {
      entry.scenes.forEach((scene, i) => {
        data.append(`scenes[${i}][id]`, scene.reportSceneId);
        data.append(`scenes[${i}][state]`, scene.state);
        data.append(
          `scenes[${i}][date]`,
          scene.date ? formatDate(scene.date) : ""
        );
        data.append(`scenes[${i}][note]`, scene.note);
        data.append(`scenes[${i}][companyId]`, scene.companyId);
      });
    }
    await saveReportEntry(data);
    this.initEntries();
  }

  async rename(entry: Report, name: string) {
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", name);
    data.append("kind", entry.kind);
    data.append("projectId", this.projectId);
    data.append("parentFolderId", this.currentFolderId);
    if (entry.scenes) {
      entry.scenes.forEach((scene, i) => {
        data.append(`scenes[${i}][id]`, scene.reportSceneId);
        data.append(`scenes[${i}][state]`, scene.state);
        data.append(
          `scenes[${i}][date]`,
          scene.date ? formatDate(scene.date) : ""
        );
        data.append(`scenes[${i}][note]`, scene.note);
        data.append(`scenes[${i}][companyId]`, scene.companyId);
      });
    }
    await saveReportEntry(data);
    this.initEntries();
  }

  async remove(entry: FolderEntry) {
    await deleteReportEntry(entry.entryId);
    await this.initEntries();
  }
}
